import { ICustomer } from "shared-types/index";

export interface IFlagPhonePicker extends IContainerProps, IHandlers {}

export interface IBaseProps {
  customerCountry: string;
  customerPhone: string;
  customerSelected?: (customer: ICustomer) => void;
  customerSearch?: (phone: string, countryCode?: string) => Promise<ICustomer[]>;
  handlePhoneChange?: (phone: string, phoneWithoutPrefix: string) => void;
  setPhoneValid?: (flag: boolean) => void;
  setPhoneTouched?: (flag: boolean) => void;
  setPhoneWithoutPrefix?: (phone: string) => void;

  validationError?: string;
  maxLength?: number;
  label?: string;
  forceTouched?: boolean;
  skipAutoComplete?: boolean;
  usePlaceholderForLabel?: boolean;
  isDropDownListMoveUp?: boolean;
  isPhoneIcon?: boolean;
  isNewCustomerForm?: boolean;
}

export interface IContainerProps extends IBaseProps{

}

export interface IProps extends IBaseProps{
  classPrefix?: string;
}

/**
 * Handlers used to modify app state (via a service) from within the module's container.
 * Similar to redux mapDispatchToProps.
 */
 export interface IHandlers {
}

export const classPrefix = 'FlagPhonePicker';
